var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBasketBall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3294_132028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.358 21.6763C65.3816 21.6763 70.2648 16.8239 70.2648 10.8381C70.2648 4.8524 65.3816 0 59.358 0C53.3343 0 48.4512 4.8524 48.4512 10.8381C48.4512 16.8239 53.3343 21.6763 59.358 21.6763Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1894 28.3589C13.0183 28.3589 8 23.3723 8 17.24C8 11.1078 13.0183 6.12109 19.1894 6.12109C25.3605 6.12109 30.3787 11.1078 30.3787 17.24C30.3787 23.3723 25.3605 28.3589 19.1894 28.3589ZM19.1894 6.68265C13.3347 6.68265 8.56512 11.4222 8.56512 17.24C8.56512 23.0578 13.3347 27.7974 19.1894 27.7974C25.044 27.7974 29.8136 23.0578 29.8136 17.24C29.8136 11.4222 25.044 6.68265 19.1894 6.68265Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 17.24C7.5 10.8286 12.7451 5.62109 19.1894 5.62109C25.6336 5.62109 30.8787 10.8286 30.8787 17.24C30.8787 23.6514 25.6336 28.8589 19.1894 28.8589C12.7451 28.8589 7.5 23.6514 7.5 17.24ZM19.1894 7.18265C13.6079 7.18265 9.06512 11.7013 9.06512 17.24C9.06512 22.7787 13.6079 27.2974 19.1894 27.2974C24.7708 27.2974 29.3136 22.7787 29.3136 17.24C29.3136 11.7013 24.7708 7.18265 19.1894 7.18265Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7948 80.0008H14.77C11.9444 80.0008 9.63867 77.7097 9.63867 74.9019V38.9395C9.63867 35.7835 12.2269 33.2115 15.4029 33.2115H26.5922L44.8682 20.1272C46.7444 18.7907 49.3326 19.049 50.9037 20.7224C51.7853 21.6659 52.2261 22.9462 52.1017 24.2378C51.9887 25.5182 51.3219 26.6974 50.2707 27.4724L29.4744 42.8479V67.6689H66.7948C70.2194 67.6689 72.9998 70.4318 72.9998 73.8349C72.9998 77.2379 70.2194 80.0008 66.7948 80.0008ZM15.3916 33.7731C12.5321 33.7731 10.1925 36.0867 10.1925 38.9395V74.9019C10.1925 77.4064 12.2382 79.4393 14.7587 79.4393H66.7948C69.903 79.4393 72.4347 76.9235 72.4347 73.8349C72.4347 70.7463 69.903 68.2305 66.7948 68.2305H28.9092V42.5672L29.0223 42.4885L49.9317 27.0231C50.8472 26.3493 51.4349 25.316 51.5366 24.1929C51.6383 23.0698 51.254 21.9466 50.4855 21.1155C49.1179 19.6442 46.8348 19.4196 45.196 20.5877L26.7731 33.7731H15.3916Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5781 19.718C46.6578 18.2365 49.5257 18.5222 51.2682 20.3783L51.269 20.3791C52.2472 21.4259 52.7371 22.8468 52.5996 24.2814C52.4734 25.7061 51.7319 27.0142 50.568 27.8725M50.568 27.8725L29.9744 43.0981V67.167H66.7948C70.4926 67.167 73.4998 70.1508 73.4998 73.8329C73.4998 77.5151 70.4926 80.4989 66.7948 80.4989H14.77C11.6712 80.4989 9.13867 77.9868 9.13867 74.8999V38.9375C9.13867 35.5024 11.9538 32.7096 15.4029 32.7096H26.4317L44.5771 19.7187L44.5781 19.718M45.4862 20.9929C45.486 20.993 45.4863 20.9928 45.4862 20.9929L26.9336 34.2712H15.3916C12.8045 34.2712 10.6925 36.3646 10.6925 38.9375V74.8999C10.6925 77.1254 12.5114 78.9373 14.7587 78.9373H66.7948C69.6298 78.9373 71.9347 76.6424 71.9347 73.8329C71.9347 71.0235 69.6298 68.7286 66.7948 68.7286H28.4092V42.3039L28.7308 42.0803L49.6353 26.6185C50.4372 26.0282 50.95 25.1243 51.0386 24.1458C51.1275 23.1647 50.7916 22.1813 50.1187 21.4534C48.9236 20.1682 46.9219 19.97 45.4862 20.9929Z",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3294_132028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 22C65.0751 22 70 17.0751 70 11C70 4.92487 65.0751 0 59 0C52.9249 0 48 4.92487 48 11C48 17.0751 52.9249 22 59 22Z",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3294_132028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 23C57.1565 18.3452 57.5085 4.46471 48 1.19209e-07",
    stroke: "#ffffff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 0C62.1516 4.65476 61.8498 18.5353 70 23",
    stroke: "#ffffff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: 11.75,
    x2: 70,
    y2: 11.75,
    stroke: "#ffffff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.25,
    y1: 1.09278e-8,
    x2: 59.25,
    y2: 23,
    stroke: "#ffffff",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3294_132028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketBall);
export default __webpack_public_path__ + "static/media/basket-ball.bc172bfe1dd167df609be553c6444ba8.svg";
export { ForwardRef as ReactComponent };